import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as Cookies from 'js-cookie';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageService {
  public onLanguageChange = new Subject();

  constructor(private http: HttpClient, private translateService: TranslateService) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get<any>(`${environment.INTERNATIONALIZATION_URL}locale_${lang}.json`);
  }

  setCookieLanguage(language: string) {
    const numberOfDays = 365;
    Cookies.set('language', language, { expires: numberOfDays, domain: `${environment.COOKIE_DOMAIN}` });
  }

  use(lang) {
    this.translateService.use(lang);
    this.setCookieLanguage(lang);
    this.onLanguageChange.next();
  }

  getCookieLanguage() {
    return Cookies.get('language');
  }

  getCurrentTranslation() {
    return this.translateService.currentLang;
  }

  setChartsLanguage() {
    this.onLanguageChange.next();
  }

  selectLanguageBasedOnBrowserSettings(): string {
    let language = this.translateService.getBrowserLang();
    language = language.match(/en|es/) ? language : 'en';
    return language;
  }
}
